var map = {
	"./app-google-da-DK.svg": 30159,
	"./app-google-de-DE.svg": 33997,
	"./app-google-en-GB.svg": 78783,
	"./app-google-en-US.svg": 44168,
	"./app-google-es-ES.svg": 64111,
	"./app-google-es-MX.svg": 88284,
	"./app-google-fr-FR.svg": 87843,
	"./app-google-it-IT.svg": 76533,
	"./app-google-nb-NO.svg": 61038,
	"./app-google-nl-NL.svg": 99803,
	"./app-google-pl-PL.svg": 88607,
	"./app-google-pt-BR.svg": 83103,
	"./app-google-pt-PT.svg": 70383,
	"./app-google-sv-SE.svg": 9406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16553;